var _path, _path2, _line, _line2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableTennis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    xmlSpace: "preserve",
    stroke: "currentColor",
    strokeWidth: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M388.2,694.5c0,0,47.7-37.8,153.7,7.2c0,0,124.8,41.5,261.1-94.8s141-310.3,18.9-432.3s-296-117.4-432.3,18.9 s-94.8,261.1-94.8,261.1c45,106,7.2,153.7,7.2,153.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.4,861.1L135.4,861.1c-28.8-28.8-27.7-75.8,2.4-103.2l264.8-241.2l77.2,77.2L238.6,858.7 C211.2,888.8,164.2,889.9,135.4,861.1z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 315.2,
    y1: 429.2,
    x2: 567.3,
    y2: 681.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 289.5,
    y1: 403.6,
    x2: 592.9,
    y2: 707
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 498.4,
    cy: 865.3,
    r: 71.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableTennis);
export default __webpack_public_path__ + "static/media/TableTennis.ee0f35f7ef85450f229137fe72537ccd.svg";
export { ForwardRef as ReactComponent };